import {environment} from '../../environments/environment';
import {MatLegacySnackBarRef as MatSnackBarRef, LegacyTextOnlySnackBar as TextOnlySnackBar} from '@angular/material/legacy-snack-bar';

export class TagObject {
    public id: number;
    public videoId: number;
    public startTime: number;
    public endTime: number;
    public type: 'url' | 'phone' | 'email' | 'none';
    public content: string;
    public x: number;
    public y: number;
    public scale: number;
    public viewType: 'image' | 'snackbar' | 'button';
    public viewContent: string;
    public transitionFade: boolean;
    public transitionScale: 'horizontal' | 'vertical' | 'none';
    public transitionMove: 'none' | 'left' | 'right' | 'top' | 'bottom' | 'rotation';

    public snackbarRef: MatSnackBarRef<TextOnlySnackBar>;

    constructor(obj: any) {
        this.id = +obj.id;
        this.videoId = +obj.video_id;
        this.startTime = +obj.start_time;
        this.endTime = +obj.end_time;
        this.type = obj.type;
        this.content = obj.content;
        this.x = +obj.x;
        this.y = +obj.y;
        this.scale = +obj.scale;
        this.viewType = obj.view_type;
        this.viewContent = obj.view_content;
        this.transitionFade = obj.transition_fade === '1';
        this.transitionScale = obj.transition_scale;
        this.transitionMove = obj.transition_move;
    }

    public getImageURL(): string {
        return environment.serverUrl + this.viewContent;
    }

}
